export default "__VITE_ASSET__C1Cu7UTS__"